import React from "react";

import Button, { ButtonProps } from "../../components/Button";
import HStack from "../../ui_atoms/HStack";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

const meta = {
    title: "Components/Button",
    component: Button,
    argTypes: {
        disabled: {
            control: { type: "boolean" },
        },
        processing: {
            control: { type: "boolean" },
        },
        shrinked: {
            control: { type: "boolean" },
        },
        buttonMode: {
            options: ["primary", "outlined", "secondary"],
            control: { type: "radio" },
        },
        size: {
            options: ["small", "medium", "large"],
            control: { type: "radio" },
        },
        shrinkToIcon: {
            options: ["menu", "close", "search", undefined],
            control: { type: "radio" },
            defaultValue: undefined,
        },
        onPress: { action: "pressed the button" },
    },
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof Button>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Simple: Story = {
    args: {
        label: "Press me!",
    },
};

export const Large: Story = {
    args: {
        label: "This is a very long button with large",
    },
};

export const ButtonInHStack: Story = ({ label, ...props }: ButtonProps) => (
    <HStack gap={0.5} fit="fill">
        <Button {...props} label="This is a lrger title" />
        <Button {...props} label={label} />
    </HStack>
);

ButtonInHStack.args = {
    label: "Press me!",
};
